import React, { useState } from "react";

const featuresList = [
  {
    title: "More then 5 profiles. ",
    description: "Subscribed feature in which new profile (upto 8) to be added with subscriptions",
    image: "/assets/Explore/create-profile.jpeg",
    key: "subscribed",
  },
  {
    title: "User with same interest can be Admirer",
    description: "Any User can be an admirer irrespective of circles. They should have of same interest.",
    image: "/assets/ExploreProfile/admirer-feature.jpeg",
    key: "admirer",
  },
  {
    title: "Professional driven social network",
    description: "Based on interest user allowed to pursue profession",
    image: "/assets/ExploreProfile/Collab-feature.jpeg",
    key: "collab",
  },
  {
    title: "Filter Feature",
    description: "Filter can be applied to further effort to get relevent contents..",
    image: "/assets/ExploreProfile/filter-feature.jpeg",
    key: "filter",
  },
  {
    title: "Global toptrend across profiles",
    description: "Global toptrend should be top ten posts with maximum impressions per 5 mins.",
    image: "/assets/ExploreProfile/global-toptrend.jpeg",
    key: "globaltrend",
  },
  {
    title: "Profile toptrends",
    description: "Top ten posts per profile based on number of impressions",
    image: "/assets/ExploreProfile/profile-toptrend.jpeg",
    key: "profiletrend",
  },
  {
    title: "per profile Media Display Mode Feature",
    description: "Choose how media appears on your profile.",
    image: "/assets/ExploreProfile/media-display.jpeg",
    key: "perprofilemedia",
  },
  {
    title: "perental control",
    description: "Parents can control profile creation and deletion of their kids account. But can't control on content",
    image: "/assets/ExploreProfile/parental-control.jpeg",
    key: "parental control",
  },
  {
    title: "security Settings",
    description: "How data can be protected during on fly or at rest can be controlled.",
    image: "/assets/ExploreProfile/security-settings.jpeg",
    key: " securitycontrol",
  },
];

const ExplorePageUAGridLayout = () => {
  const [selectedFeatures, setSelectedFeatures] = useState({});

  const handleCheckboxChange = (key) => {
    setSelectedFeatures((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleSubmit = () => {
    const selected = featuresList
      .filter((feature) => selectedFeatures[feature.key])
      .map((f) => f.title);

    if (selected.length === 0) {
      alert("Please select at least one feature to explore.");
      return;
    }

    alert(`You've selected to explore:\n\n- ${selected.join("\n- ")}`);
  };

  return (
    <div style={{ padding: 30, fontFamily: "Arial" }}>
      <h1 className="cmn-text-header" style={{ textAlign: "center", marginBottom: 30, fontSize: 40 }}>Explore Features</h1>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
          gap: "24px",
        }}
      >
        {featuresList.map((feature) => (
          <div
            key={feature.key}
            style={{
              border: "1px solid #ccc",
              borderRadius: 10,
              padding: 20,
              background: "#fafafa",
              boxShadow: "2px 2px 10px rgba(0,0,0,0.05)",
              textAlign: "center",
            }}
          >
            <h2 style={{ fontSize: "18px", marginBottom: 10 }}>{feature.title}</h2>
            <p style={{ fontSize: "14px", color: "#555" }}>{feature.description}</p>
            <img
              src={feature.image}
              alt={feature.title}
              style={{
                width: "100%",
                maxWidth: 200,
                height: "auto",
                margin: "15px auto",
                borderRadius: 6,
              }}
            />
            <div>
              <label>
                <input
                  type="checkbox"
                  checked={!!selectedFeatures[feature.key]}
                  onChange={() => handleCheckboxChange(feature.key)}
                />{" "}
                Explore this feature
              </label>
            </div>
          </div>
        ))}
      </div>

      <div style={{ textAlign: "center", marginTop: 40 }}>
        <button
          onClick={handleSubmit}
          style={{
            padding: "12px 24px",
            fontSize: 16,
            backgroundColor: "#007BFF",
            color: "white",
            border: "none",
            borderRadius: 6,
            cursor: "pointer",
          }}
        >
          Submit
        </button>
      </div>
    </div>
  );
};

export default ExplorePageUAGridLayout;
